import React from 'react';

const AboutPage = () => (<div>About</div>);

export default AboutPage;


// WEBPACK FOOTER //
// ./src/components/5.environments/AboutPage/index.js